module.exports = __webpack_public_path__ + "static/media/error.9b1ca3a1.png";